import { IHisPolicy, IProductInsurance } from "./types";

export default class ProductInsurance implements  IProductInsurance {

  public hisPolicies: IHisPolicy[];
  public numberPriceRate: number;


  constructor(hisPolicies: IHisPolicy[], numberPriceRate: number) {
    this.hisPolicies = hisPolicies;
    this.numberPriceRate = numberPriceRate;
  }

}
